var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.75 59.719l-7.031 7.031-30-30 30-30 7.031 7.031L31.781 36.75 54.75 59.719z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "chevron-left_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 6,
    width: 38,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.75 59.719l-7.031 7.031-30-30 30-30 7.031 7.031L31.781 36.75 54.75 59.719z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chevron-left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.75-233.25v540h-540v-540z"
  }))));
}
export default SvgChevronLeft;